import { createApp } from 'vue';
import '../styles/main.scss';
import AktionQuiz from './components/AktionQuiz.vue';
import helperPlugin from './utils/helpers';
import { vfmPlugin } from 'vue-final-modal';
window.addEventListener('DOMContentLoaded', function () {
	let aktionQuizForms = document.querySelectorAll('.aktion-quiz-form');
	if (aktionQuizForms.length) {
		aktionQuizForms.forEach(function (quizForm) {
			let quizId = quizForm.dataset.quizId;
			if (quizId) {
				const app = createApp(AktionQuiz, { id: quizId });
				app.use(helperPlugin);
				app.use(vfmPlugin);
				app.mount(quizForm);
			}
		});
	}
});
